import { render } from "./RemoveButton.vue?vue&type=template&id=1e046571&scoped=true"
import script from "./RemoveButton.vue?vue&type=script&lang=js"
export * from "./RemoveButton.vue?vue&type=script&lang=js"

import "./RemoveButton.vue?vue&type=style&index=0&id=1e046571&scoped=true&lang=css"

import exportComponent from "C:\\Users\\brettp\\Documents\\Workspaces\\dealer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e046571"]])

export default __exports__